<template>
  <button class="NormalBtn" @click="$emit('click')" :dosabled="$emit('disabled')">
      <slot></slot>
  </button>
</template>

<script>
export default {
  name: "NormalBtn",
  computed: {}
}
</script>

<style lang="scss" scoped>
.NormalBtn {
  margin: 20px 30px 0;
  padding: 1.1em 0;
  font-size: 16px;
  color: #FFF;
  width: 315px;
  text-align: center;
  background-color: #F63C5B;
  border-radius: 50px;
  cursol: pointer;
  transition: 0.3s;
  outline: none;
  &.disabled,
  &:disabled {
    background-color: #D4D4D4;
    color: #6C6C6C;
  }
  @media screen and (min-width:376px){
    &:hover:not(:disabled) { background-color: #FF7A91; }
    &:active:not(:disabled) { background-color: #F9607A; }
  }
}
</style>
